/**
 * @flow
 * @relayHash cd49ac7f1d4c44e42391e1d6ec0afb15
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SbRespLayout_viewer$ref = any;
type detectPageExistsAndRedirect_viewer$ref = any;
type getDomainLinksSb_viewer$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespRootQueryVariables = {|
  userId?: ?string,
  fetchUser: boolean,
  uriRef?: ?string,
  first: number,
  page: number,
  localeOrigin?: ?string,
  isTrade: boolean,
  showSeller: boolean,
  followSearchPages?: ?$ReadOnlyArray<?string>,
  followSearchTypes?: ?$ReadOnlyArray<?types>,
  contentModuleId?: ?string,
  eligibleAbTest?: ?string,
  userZipCode?: ?string,
  isClient: boolean,
|};
export type sbRespRootQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: getDomainLinksSb_viewer$ref & SbRespLayout_viewer$ref & detectPageExistsAndRedirect_viewer$ref
  |}
|};
export type sbRespRootQuery = {|
  variables: sbRespRootQueryVariables,
  response: sbRespRootQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localeOrigin",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchTypes",
    "type": "[types]",
    "defaultValue": [
      "SEARCH"
    ]
  },
  {
    "kind": "LocalArgument",
    "name": "contentModuleId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "eligibleAbTest",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": "0"
  },
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef",
  "type": "String"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rank",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hexCode",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedFilterName",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "photo",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v24 = [
  (v18/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v24/*: any*/)
},
v26 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade",
  "type": "Boolean"
},
v27 = [
  (v26/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "searchAndBrowse",
    "type": "PageDisplayEnum"
  }
],
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v14/*: any*/)
  ]
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "paragraphs",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewParagraph",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "text",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "mobileText",
      "name": "text",
      "args": [
        {
          "kind": "Literal",
          "name": "formatType",
          "value": "MOBILE",
          "type": "formatTextTypes"
        }
      ],
      "storageKey": "text(formatType:\"MOBILE\")"
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "alias": "mobileTitle",
  "name": "title",
  "args": [
    {
      "kind": "Literal",
      "name": "formatType",
      "value": "MOBILE",
      "type": "formatTitleTypes"
    }
  ],
  "storageKey": "title(formatType:\"MOBILE\")"
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustomizable",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": (v27/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v29/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantityDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    (v30/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v23/*: any*/)
      ]
    },
    (v23/*: any*/)
  ]
},
v39 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1,
    "type": "Int"
  },
  {
    "kind": "Literal",
    "name": "skipImageService",
    "value": true,
    "type": "Boolean"
  }
],
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "webPath",
      "args": null,
      "storageKey": null
    }
  ]
},
v41 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1,skipImageService:true)",
  "args": (v39/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    (v40/*: any*/),
    (v23/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "dimensions",
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true,
          "type": "Boolean"
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter"
          ],
          "type": "[measurementFieldType]"
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " ",
          "type": "String"
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unit",
          "args": null,
          "storageKey": null
        },
        (v42/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": [
        (v42/*: any*/)
      ]
    }
  ]
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "sellerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "SellerProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company",
      "args": null,
      "storageKey": null
    }
  ]
},
v45 = [
  (v9/*: any*/),
  (v8/*: any*/)
],
v46 = [
  (v26/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false,
      "type": "Boolean"
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v50 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "benefit",
    "args": null,
    "storageKey": null
  }
],
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "iconUri",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sbRespRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "getDomainLinksSb_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "SbRespLayout_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "detectPageExistsAndRedirect_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "sbRespRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchBrowse",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "eligibleAbTest",
                "variableName": "eligibleAbTest",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "localeOrigin",
                "variableName": "localeOrigin",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              (v2/*: any*/)
            ],
            "concreteType": "SearchBrowseQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "meta",
                "storageKey": null,
                "args": null,
                "concreteType": "MetaData",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canonical",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prev",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "disableIndexing",
                    "args": null,
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "next",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "microdata",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "spellCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "SpellcheckSuggestions",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "redirect",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SpellcheckSuggestionsRedirected",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "redirectTo",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "redirectFrom",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "newQuery",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SpellcheckSuggestionsValues",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "uri",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "oldQuery",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "appliedFilters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v6/*: any*/),
                      (v12/*: any*/)
                    ]
                  },
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBeDismissed",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "topCategoryL1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayMaxNumberOfPages",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canShowNoAttributeSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "filters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseFilter",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilterValue",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "stats",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "stats",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "values",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalCount",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "browseContentModule",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "contentModuleId",
                    "variableName": "contentModuleId",
                    "type": "String"
                  }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moduleType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "ContentModuleBanner",
                    "selections": [
                      (v16/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subtitle",
                        "args": null,
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "linkText",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "ContentModuleRegular",
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canFollowSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "languageAnnotations",
                "storageKey": null,
                "args": null,
                "concreteType": "LanguageAnnotations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "available",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "href",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hrefLang",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "breadcrumbs",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseBreadcrumbs",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "path",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": "displayPriceTracking",
                        "name": "displayPrice",
                        "storageKey": null,
                        "args": (v27/*: any*/),
                        "concreteType": "ItemDisplayPriceType",
                        "plural": true,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quickViewDisplay",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewDisplayType",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v3/*: any*/),
                          (v32/*: any*/)
                        ]
                      },
                      (v33/*: any*/),
                      (v3/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v41/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": (v27/*: any*/),
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showMakeOffer",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      (v43/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photos",
                        "storageKey": "photos(limit:1,skipImageService:true)",
                        "args": (v39/*: any*/),
                        "concreteType": "ItemPhoto",
                        "plural": true,
                        "selections": [
                          (v40/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "showSeller",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "sort",
                "storageKey": null,
                "args": null,
                "concreteType": "SortType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "options",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseSortAvailableOptions",
                    "plural": true,
                    "selections": (v45/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentOption",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseSortCurrentOption",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canShowRecommendedSort",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "priceTiles",
                "storageKey": null,
                "args": (v46/*: any*/),
                "concreteType": "SearchBrowsePriceTile",
                "plural": true,
                "selections": [
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryTiles",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseCategoryTiles",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemId",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "relatedItems",
                "name": "thinBrowseRelatedItems",
                "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 12,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "seller",
                    "value": "INCLUDE",
                    "type": "seller"
                  }
                ],
                "concreteType": "searchBrowseMoreLikeThisConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "searchBrowseMoreLikeThisEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v33/*: any*/),
                          (v18/*: any*/),
                          (v34/*: any*/),
                          (v3/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v17/*: any*/),
                          (v41/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "quickViewDisplay",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "QuickViewDisplayType",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v32/*: any*/),
                              (v31/*: any*/)
                            ]
                          },
                          (v21/*: any*/),
                          (v43/*: any*/),
                          (v20/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "showSeller",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "seller",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Seller",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v44/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "internalBuyLinks",
                "storageKey": null,
                "args": null,
                "concreteType": "InternalBuyLinkType",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "anchorText",
                    "args": null,
                    "storageKey": null
                  },
                  (v47/*: any*/),
                  (v23/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageExists",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "redirect",
                "storageKey": null,
                "args": null,
                "concreteType": "redirectType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "priceTiles",
                    "storageKey": null,
                    "args": (v46/*: any*/),
                    "concreteType": "SearchBrowsePriceTile",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v48/*: any*/),
                      (v47/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "facets",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseFacets",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "location",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FacetValueType",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      (v23/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isContentModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "BROWSE_CONTENT_MODULES",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isBillboardAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isThinSearchBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTileAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSkyscraperAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMatchedSetsEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableMatchedSetsFacet",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFINE_MENU_SEARCH",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isDeliveryOptionsDisabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isShopByRoomEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SHOP_BY_ROOM",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbRespFollowSearchBannerEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbRespFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v1/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disablePriceTiles",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disablePriceTiles",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"disablePriceTiles\")"
          },
          (v23/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canShowInternalSellerName",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_SELLER_NAME",
                        "type": "String!"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favorites",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1,
                        "type": "Int"
                      },
                      {
                        "kind": "Variable",
                        "name": "pages",
                        "variableName": "followSearchPages",
                        "type": "[String]"
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "followSearchTypes",
                        "type": "[types]"
                      }
                    ],
                    "concreteType": "favoritesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "plural": false,
                            "selections": (v24/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "recentHistoryList",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RecentHistoryItem",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "small",
                                "type": "ImageVersionTypeName!"
                              }
                            ],
                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdpURL",
                            "args": null,
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v25/*: any*/),
                          (v23/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v23/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"TRADESHIP\",\"RISKFREE\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 14,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADESHIP",
                              "RISKFREE"
                            ],
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v49/*: any*/),
                          (v10/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "educationMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v50/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pointsToMaintainStatus",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pointsMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v50/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "homepageMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v50/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "postCheckoutMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v50/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tpnRole",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmTPNRole",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isTrade",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "loyalty",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmLoyaltyType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentYearSpend",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "status",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "rewards",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v8/*: any*/),
                                          (v51/*: any*/),
                                          (v23/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "nextProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v51/*: any*/),
                                          (v23/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId",
                                "type": "String"
                              }
                            ],
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "segmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v49/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeProgramsQuery",
                "storageKey": "tradeProgramsQuery(programCodes:[\"BRONZE\"])",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "programCodes",
                    "value": [
                      "BRONZE"
                    ],
                    "type": "[String]"
                  }
                ],
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": [
                  (v51/*: any*/),
                  (v23/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingFilters",
                    "storageKey": null,
                    "args": [
                      (v2/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "zipCode",
                        "variableName": "userZipCode",
                        "type": "String"
                      }
                    ],
                    "concreteType": "ShippingFilterType",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "plural": true,
                        "selections": (v45/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "parentPrograms",
                    "name": "tradeProgramsQuery",
                    "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "programCodes",
                        "value": [
                          "MEMBER",
                          "BRONZE",
                          "SILVER",
                          "GOLD",
                          "PLATINUM"
                        ],
                        "type": "[String]"
                      }
                    ],
                    "concreteType": "LoyaltyProgram",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v8/*: any*/),
                      (v51/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "maxPoints",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "minPoints",
                        "args": null,
                        "storageKey": null
                      },
                      (v23/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "sbRespRootQuery",
    "id": "app-buyer-finding/213.0.0-2019-04-23T14:40:24.662Z/sbRespRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5c566aea0fa9a5ec9817327d3a03ef11';
module.exports = node;
